import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { UserLoadAlertService } from "./user-load-alert.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: "app-user-load-alert",
  templateUrl: "./user-load-alert.component.html",
  styleUrls: ["./user-load-alert.component.sass"],
})
export class UserLoadAlertComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private userLoadAlertService: UserLoadAlertService,
    private router: Router,
  ) {}

  allPosts: any[] = [];
  itemsPerPage: number = 10;
  totalItems: number = 0;
  page: number = 1;

  ngOnInit(): void {
    this.getAllUserAlerts(this.page);
  }

  getAllUserAlerts(page: number): void {
    this.spinner.show();
    const data = {
      limit: this.itemsPerPage,
      page: page,
    };

    this.userLoadAlertService.getUserAlerts(data).subscribe({
      next: (result: any) => {
        if (result.statusCode === 200) {
          this.allPosts = result.data;
          this.totalItems = result.pagination?.total || 0;
        } else {
          this.toastr.error(result.message || "Something went wrong");
        }
      },
      error: (err) => {
        this.toastr.error("API Error");
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }
}
